module.exports = __webpack_public_path__ + "img/8.564c61b4.png";